import React, { createContext, useContext, useEffect, useState } from 'react';

type Theme = 'dark' | 'light';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Force light mode
  const [theme] = useState<Theme>('light');

  useEffect(() => {
    const root = document.documentElement;
    // Remove previous theme class/attribute
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    
    // Also set data-theme attribute for potential other usage
    root.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    // Theme switching disabled
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

